import React, { Component } from 'react';
import moment from "moment-timezone";
import {isEmpty, map} from 'lodash';

import treeicon from "../../../../Assets/images/treeicon.png";

const communityTypeData = {townhomes: 'Townhomes', detached: 'Detached Homes', condo: 'Condominium', apartment: 'Apartment'}

const communityRoleData = [
  {
    name: 'Board Member',
    value: 'board_member'
  },
  {
    name: 'Community Manager',
    value: 'community_manager'
  },
  {
    name: 'Concerned Resident',
    value: 'concerned_resident'
  },
];
const preferredContactData = [
  {
    name: 'Text',
    value: 'text'
  },
  {
    name: 'Home Phone',
    value: 'phone'
  },
  {
    name: 'Email',
    value: 'email'
  },
  {
    name: 'Office',
    value: 'office'
  },
];
const productData = [
  {
    name: 'Pet Waste Stations',
    value: 'pet_waste_stations'
  },
  {
    name: 'Pet Waste Station Bags',
    value: 'pet_waste_station_bags'
  }
];
const bagsData = [
  {
    name: 'Header Bags',
    value: 'header_bags'
  },
  {
    name: 'Roll Bags',
    value: 'roll_bags'
  },
  {
    name: 'I Don’t Know',
    value: 'dont_know'
  },
];
const stationInstallingData = [
  {
    name: '1-5',
    value: '1-5'
  },
  {
    name: '6-10',
    value: '6-10'
  },
  {
    name: '11-20+',
    value: '11-20+'
  },
  {
    name: 'I Don’t Know',
    value: 'dont_know'
  }
];
const serviceFrequencyData = [
  {
    name: 'Twice Weekly',
    value: 'twice weekly'
  },
  {
    name: 'Weekly',
    value: 'weekly'
  },
  {
    name: 'Every Other Week',
    value: 'every other week'
  },
  {
    name: 'Other',
    value: 'other'
  }
];
const cleaningAreasData = [
  {
    name: 'All Common Areas',
    value: 'all_common_areas'
  },
  {
    name: 'Specific Locations',
    value: 'specific_locations'
  }
];

class SideBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      commercialData: {},
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (Object.keys(nextProps?.commercialData).length > 0 && JSON.stringify(nextProps?.commercialData) !== JSON.stringify(this.state.commercialData)) {
      this.setState({ commercialData: nextProps.commercialData });
    }
  }

  // render info box
  renderInfoBox = (label, text, showImage) => {
    return (
      <div className="contact-info">
        <h4 className="primary">{label}</h4>
        <h5 className="primary d-flex align-items-start">
          {showImage && <img className="mr-2 hide-md" src={treeicon} alt={""} />}
          <span className="">{text}</span>
        </h5>
      </div>
    )
  };

  // render contact info
  renderContactInfo = () => {
    const {
      first_name = '',
      last_name = '',
      management_company = '',
      email_address = '',
      phone_numbers,
      role,
      reach_out_via,
    } = this.state.commercialData || {};

    const contact_number = phone_numbers?.map(obj => obj.phone);
    // eslint-disable-next-line
    const reachOut = reach_out_via?.map(data => {
      const idx = preferredContactData?.findIndex(obj => obj.value === data);
      if (idx > -1) {
        return preferredContactData[idx]?.name;
      }
    });

    let communityRole = '';
    const idx = communityRoleData?.findIndex(obj => obj.value === role);
    if (idx > -1) {
      communityRole = communityRoleData[idx]?.name;
    }

    return (
      <div className="contact-info">
        <p>{`${first_name} ${last_name}`}</p>
        <p>{communityRole}</p>
        {management_company && <p>{management_company}</p>}
        <p>{email_address}</p>
        <p>{contact_number?.toString()}</p>
        <p>{`Contact By ${reachOut?.toString() || '-'}`}</p>
      </div>
    )
  };

  // render community info
  renderCommunityInfo = () => {
    const {
      management_company = '',
      properties_in_community = [],
      home_count = '',
      would_like_more_info = false,
      address = {},
      is_looking_for_proposal = false
    } = this.state.commercialData || {};

    const communityProperties = properties_in_community?.map(x => communityTypeData[x])

    return (
      <div>
        <p>{`${!isEmpty(communityProperties) ? communityProperties?.join(', ') : ''} ${home_count ? `, ${home_count}` : ''}`}</p>
        {
          !would_like_more_info && is_looking_for_proposal && !isEmpty(address?.address) &&
            <div>
              <p>{address?.address || ''}</p>
              <p>{`${address?.city || ''} ${address?.state || ''}, ${address?.zip_code || ''}`}</p>
              {management_company && <p>{`Managed by ${management_company}`}</p>}
            </div>
        }
      </div>
    )
  };

  // render pet waste info
  renderPetWaste = () => {
    const {
      is_pet_waste_stations_installed,
      existing_pet_waste_stations_count,
      new_pet_waste_stations_interested,
      bag_type,
    } = this.state.commercialData || {};

    // eslint-disable-next-line
    const bagType = bag_type?.map(data => {
      const idx = bagsData?.findIndex(obj => obj.value === data);
      if (idx > -1) {
        return bagsData[idx]?.name
      }
    });

    let stationInterested = ''
    const idx = stationInstallingData?.findIndex(obj => obj.value === new_pet_waste_stations_interested);
    if (idx > -1) {
      stationInterested = stationInstallingData[idx]?.name
    }

    return (
      <div>
        <p>{`Pet waste stations`}</p>
        <p>{(is_pet_waste_stations_installed && existing_pet_waste_stations_count) ? `${existing_pet_waste_stations_count} stations using ${bagType?.join(', ')}` : ''}</p>
        <p>{(stationInterested) ? `${stationInterested} stations` : ''}</p>
      </div>
    )
  };

  // render trash can info
  renderTrashCan = () => {
    const {
      trash_cans_count,
      is_trash_cans_installed,
      new_trash_cans_interested
    } = this.state.commercialData || {};

    let stationInterested = '';
    const idx = stationInstallingData?.findIndex(obj => obj.value === new_trash_cans_interested);
    if (idx > -1) {
      stationInterested = stationInstallingData[idx]?.name
    }

    return (
      <div>
        <p>{`Trash can service`}</p>
        <p>{(is_trash_cans_installed && trash_cans_count) ? `${trash_cans_count} stations` : ''}</p>
        <p>{stationInterested ? `${stationInterested} stations` : ''}</p>
      </div>
    )
  };

  // render service frequency data
  renderServiceFrequencyData = () => {
    const {
      current_frequency,
    } = this.state.commercialData || {};

    let currentfrequency = ''
    const idx = serviceFrequencyData?.findIndex(obj => obj.value === current_frequency);
    if (idx > -1) {
      currentfrequency = serviceFrequencyData[idx]?.name
    }

    return (
      <div>
        <p>{currentfrequency ? `${currentfrequency} Service` : ''}</p>
      </div>
    )
  };

  // render cleaning area
  renderCleaningArea = () => {
    const {
      areas_to_clean
    } = this.state.commercialData || {};

    let area = []
    map(areas_to_clean, x => {
      const idx = cleaningAreasData?.findIndex(obj => obj.value === x);
      if (idx > -1) {
        area.push(cleaningAreasData[idx]?.name)
      }
    })

    return (
      <div>
        <p>{`Common area cleaning`}</p>
        <p>{area?.length > 0 ? `${area?.join(', ')}` : ''}</p>
      </div>
    )
  };

  // render proposal date
  renderProposalDate = () => {
    const {
      is_looking_for_proposal,
      proposal_due
    } = this.state.commercialData || {};

    return (
      <div>
        <p>{`${(is_looking_for_proposal && proposal_due) ? moment(proposal_due)?.format('YYYY-MM-DD') : '-'}`}</p>
      </div>
    )
  }

  // render service need
  renderServiceNeed = () => {
    const {
      interested_services,
      is_trash_cans_installed,
      is_pet_waste_stations_installed,
      interested_products
    } = this.state.commercialData || {};

    // eslint-disable-next-line
    const products = interested_products?.map(data => {
      const idx = productData?.findIndex(obj => obj.value === data);
      if (idx > -1) {
        return productData[idx]?.name
      }
    });

    const isPetWasteStation = interested_services?.includes("pet_waste_station_service");
    const isCommonCleaningArea = interested_services?.includes("common_area_cleaning");
    const isTrashCan = interested_services?.includes("trash_can_service");

    return (
      <div>
        {isPetWasteStation && this.renderPetWaste()}
        {isTrashCan && this.renderTrashCan()}
        {((isTrashCan && is_trash_cans_installed) || (isPetWasteStation && is_pet_waste_stations_installed)) && this.renderServiceFrequencyData()}
        {isCommonCleaningArea && this.renderCleaningArea()}
        <p>{`Products needed: ${products?.join(', ') || '-'}`}</p>
      </div>
    )
  };

  render() {
    return (
      <div className="aside-bar">
        <div className="acol">
          <h2 className="primary hide-md">{'Community Summary' }</h2>
          <h5 className="primary">{this.renderInfoBox('Contact information', this.renderContactInfo())}</h5>
          <hr />
          <h5 className="primary">{this.renderInfoBox('Community information', this.renderCommunityInfo())}</h5>
          <span></span>
          <hr />
          <h5 className="primary d-flex align-items-start">{this.renderInfoBox('Service needs', this.renderServiceNeed(), true)}</h5>
          <hr />
          <h5 className="primary">{this.renderInfoBox('Date proposal due', this.renderProposalDate())}</h5>
        </div>
      </div>
    )
  }
}

export default SideBar;